import React from 'react';

const Page404 = ({className}) => {
    return (
        <div className={`min-h-50 py-20 d-flex ${className}`}>
            <div className="m-auto text-center">
                <h1 className='display-1'>Oops!</h1>
                <h1>Page Not Found</h1>
            </div>
        </div>
    );
}
Page404.defaultProps = {
    className: 'container'
};

export default Page404;
